import React from "react";
import { IconProps } from "./IconProps";

const ArrowUp: React.FC<IconProps> = ({
  size = 20,
  color = "#F7F9F9",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
      {...props}
    >
      <path
        d="M8.052 13.3333V2.66663M8.052 2.66663L4.052 6.66663M8.052 2.66663L12.052 6.66663"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowUp;
